import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: {},
    },
    currentProgram: {
      id: String,
      Price: Number,
      description: String,
      Time: String,
    },
  },
  mutations: {
    Login(state) {
      state.user.loggedIn = true;
    },
    Logout(state) {
      state.user.loggedIn = false;
    },
    changeCurrentProgram(state, currentProg) {
      state.currentProgram.id = currentProg.id;
      state.currentProgram.Time = currentProg.Time;
      state.currentProgram.Price = currentProg.Price;
      state.currentProgram.description = currentProg.description;
    },
  },
  actions: {
    Login({ commit }) {
      commit("Login");
    },
    Logout({ commit }) {
      commit("Logout");
    },
    UpdateWantedProgram({ commit }, currentProg) {
      commit("changeCurrentProgram", currentProg);
    },
  },
  modules: {},
});
